(function() {
  const cartBtn = document.querySelector('a[aria-label="Cart"]');
  if (!cartBtn) return;

  const dropdown = document.createElement('div');
  dropdown.id = 'cart-hover-dropdown';
  dropdown.style.cssText = `
    position: absolute;
    top: 100%;
    right: 0;
    width: 320px;
    background: #FFFFFF;
    border: 1px solid #e8e8e8;
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    z-index: 9999;
    padding: 20px;
    display: none;
    font-family: inherit;
    color: #FFFFFF;
  `;

  cartBtn.parentElement.style.position = 'relative';
  cartBtn.parentElement.appendChild(dropdown);

  let hoverTimer, hideTimer;

  function showDropdown() {
    clearTimeout(hideTimer);
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count === 0) {
          dropdown.innerHTML = `
            <p style="margin:0 0 12px;font-size:14px;color:#3D3D3D;">Your cart is empty.</p>
            <a href="/collections/all-products" style="display:block;text-align:center;padding:10px;background:#823034;color:#FFFFFF;text-decoration:none;font-size:13px;letter-spacing:0.05em;border:1px solid #823034;">SHOP BEST SELLERS</a>
          `;
        } else {
          let itemsHtml = cart.items.map(item => `
            <div style="display:flex;gap:12px;margin-bottom:12px;align-items:center;">
              <img src="${item.image}" style="width:50px;height:50px;object-fit:cover;" />
              <div style="flex:1;font-size:13px;color:#1C1C1C;">
                <div style="font-weight:600;">${item.product_title}</div>
                <div style="color:#3D3D3D;">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
                <div style="color:#3D3D3D;">Qty: ${item.quantity} &nbsp;|&nbsp; $${(item.final_line_price / 100).toFixed(2)}</div>
              </div>
            </div>
          `).join('');

          dropdown.innerHTML = `
            ${itemsHtml}
            <div style="border-top:1px solid #e8e8e8;padding-top:12px;margin-top:4px;display:flex;justify-content:space-between;align-items:center;">
              <span style="font-size:13px;font-weight:600;color:#1C1C1C;">Subtotal</span>
              <span style="font-size:13px;color:#1C1C1C;">$${(cart.total_price / 100).toFixed(2)} AUD</span>
            </div>
            <a href="/cart" style="display:block;text-align:center;padding:10px;margin-top:12px;background:#823034;color:#FFFFFF;text-decoration:none;font-size:13px;letter-spacing:0.05em;border:1px solid #823034;">VIEW CART</a>
          `;
        }
        dropdown.style.display = 'block';
      });
  }

  function hideDropdown() {
    hideTimer = setTimeout(() => {
      dropdown.style.display = 'none';
    }, 300);
  }

  cartBtn.addEventListener('mouseenter', () => {
    clearTimeout(hideTimer);
    hoverTimer = setTimeout(showDropdown, 200);
  });

  cartBtn.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimer);
    hideDropdown();
  });

  dropdown.addEventListener('mouseenter', () => clearTimeout(hideTimer));
  dropdown.addEventListener('mouseleave', hideDropdown);
})();
